import { HeadingSection } from "@components/headings/HeadingSection";

export const PillGrid = ({
  children,
  title,
  description,
}: {
  children: React.ReactNode;
  description?: null | string;
  title?: null | string;
}) => {
  return (
    <>
      {title && (
        <HeadingSection description={description} level={2} variant='large'>
          {title}
        </HeadingSection>
      )}
      <div className='mb-48 flex flex-col items-stretch py-2'>
        <div className='grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5'>{children}</div>
      </div>
    </>
  );
};
